<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';
import { ref, watch } from 'vue';
import { watchDebounced } from '@vueuse/core';

const modelValue = defineModel({
    type: String,
    required: true,
});

const localSearch = ref(modelValue.value);

watch(modelValue, (newValue) => {
    if (newValue !== localSearch.value) {
        localSearch.value = newValue;
    }
});

watchDebounced(
    localSearch,
    (value) => {
        modelValue.value = value;
    },
    { debounce: 500, maxWait: 1000 }
);
</script>

<template>
    <div class="border-b-primary mt-6 flex w-full max-w-full min-w-0 items-center border-b">
        <div class="relative grow">
            <input
                v-model="localSearch"
                type="text"
                :placeholder="$t('invoices.search')"
                class="placeholder:text-neutrals-700 w-full border-0 bg-transparent pr-6 pl-0 text-sm focus:border-0 focus:ring-0 focus:outline-hidden"
            />
            <button
                v-show="localSearch !== ''"
                type="button"
                class="absolute top-2 right-6 bottom-0 size-4 cursor-pointer"
                @click.prevent="localSearch = ''"
            >
                <CFIcon
                    name="close"
                    class="size-4"
                />
            </button>
            <div class="absolute top-2 right-0 bottom-0 size-4">
                <CFIcon
                    name="search"
                    class="size-4"
                />
            </div>
        </div>
    </div>
</template>
